<div class="modal-header">
    <div class="search-field">
        <span class="search-field-icon"><i class="bi bi-search" aria-hidden="true"></i></span>
        <input
            ngbAutofocus
            type="text"
            class="search-field-input"
            autocomplete="off"
            [maxlength]="maxQueryLength"
            [formControl]="searchControl"
            [attr.aria-label]="'titles_search' | translate: 'online' : 'systems'"
            [placeholder]="'search_placeholder' | translate: 'online' : 'ngonline'" />
        @if (searchControl.value !== '') {
            <button type="button" class="btn btn-link search-field-clear" (click)="clear()">
                {{ 'search_clear' | translate: 'online' : 'ngonline' }}
            </button>
        }
    </div>
    <button
        type="button"
        class="btn-close ms-3"
        aria-label="Close"
        (click)="activeModal.dismiss()"></button>
</div>
<div class="modal-body">
    @if (view$ | async; as view) {
        @switch (view.status) {
            @case ('tooShort') {
                <p class="text-muted mb-0">
                    {{
                        'search_minLength'
                            | translate: 'online' : 'ngonline' : [minQueryLength.toString()]
                    }}
                </p>
            }
            @case ('loading') {
                <app-load />
            }
            @case ('error') {
                <p class="text-danger mb-0">
                    {{ 'search_error' | translate: 'online' : 'ngonline' }}
                </p>
            }
            @case ('loaded') {
                @if (!view.hasHits) {
                    <p class="text-muted mb-0">
                        {{ 'table_noResults' | translate: 'online' : 'common' }}
                    </p>
                }

                <div class="row g-3">
                    @if (view.hasPlaceHits) {
                        <div class="col-lg d-flex flex-column gap-3">
                            @if (view.systems.totalCount > 0) {
                                <section class="card">
                                    <div class="card-header">
                                        <h2 class="search-group-title">
                                            {{ 'titles_systems' | translate: 'online' : 'common' }}
                                            <ng-container
                                                *ngTemplateOutlet="
                                                    resultCount;
                                                    context: {$implicit: view.systems.totalCount}
                                                " />
                                        </h2>
                                    </div>
                                    <div class="list-group list-group-flush">
                                        @for (row of view.systems.rows; track row.item.buildingNo) {
                                            <a
                                                class="list-group-item list-group-item-action search-hit"
                                                [routerLink]="row.link"
                                                (click)="activeModal.close()">
                                                <span class="search-hit-title">
                                                    <span class="search-part">{{
                                                        row.item.buildingNo
                                                    }}</span>
                                                    @if (row.item.buildingName != null) {
                                                        <span class="search-part">{{
                                                            row.item.buildingName
                                                        }}</span>
                                                    }
                                                </span>
                                                @if (row.item.proBraSummary !== '') {
                                                    <span class="search-hit-detail">
                                                        {{
                                                            'properties_proBra'
                                                                | translate: 'online' : 'systems'
                                                        }}
                                                        {{ row.item.proBraSummary }}
                                                    </span>
                                                }
                                                @if (row.item.address != null) {
                                                    <span class="search-hit-context">{{
                                                        row.item.address
                                                    }}</span>
                                                }
                                            </a>
                                        }
                                    </div>
                                    <ng-container
                                        *ngTemplateOutlet="
                                            showingFirst;
                                            context: {$implicit: view.systems}
                                        " />
                                </section>
                            }

                            @if (view.locations.totalCount > 0) {
                                <section class="card">
                                    <div class="card-header">
                                        <h2 class="search-group-title">
                                            {{
                                                'titles_apartments'
                                                    | translate: 'online' : 'systems'
                                            }}
                                            <ng-container
                                                *ngTemplateOutlet="
                                                    resultCount;
                                                    context: {$implicit: view.locations.totalCount}
                                                " />
                                        </h2>
                                    </div>
                                    <div class="list-group list-group-flush">
                                        @for (
                                            row of view.locations.rows;
                                            track row.item.locationId
                                        ) {
                                            <a
                                                class="list-group-item list-group-item-action search-hit"
                                                [routerLink]="row.link"
                                                (click)="activeModal.close()">
                                                <span class="search-hit-title">
                                                    <span class="search-part">{{
                                                        row.item.locationId
                                                    }}</span>
                                                    @if (row.item.address != null) {
                                                        <span class="search-part">{{
                                                            row.item.address
                                                        }}</span>
                                                    }
                                                </span>
                                                <span class="search-hit-detail">
                                                    @if (row.item.proBraLoc != null) {
                                                        <span class="search-part">{{
                                                            row.item.proBraLoc
                                                        }}</span>
                                                    }
                                                    @if (row.item.consumerId != null) {
                                                        <span class="search-part">{{
                                                            row.item.consumerId
                                                        }}</span>
                                                    }
                                                    @if (row.item.consumerName != null) {
                                                        <span class="search-part">{{
                                                            row.item.consumerName
                                                        }}</span>
                                                    }
                                                </span>
                                                <ng-container
                                                    *ngTemplateOutlet="
                                                        systemContext;
                                                        context: {$implicit: row.item}
                                                    " />
                                            </a>
                                        }
                                    </div>
                                    <ng-container
                                        *ngTemplateOutlet="
                                            showingFirst;
                                            context: {$implicit: view.locations}
                                        " />
                                </section>
                            }

                            @if (view.meters.totalCount > 0) {
                                <section class="card">
                                    <div class="card-header">
                                        <h2 class="search-group-title">
                                            {{ 'search_meters' | translate: 'online' : 'ngonline' }}
                                            <ng-container
                                                *ngTemplateOutlet="
                                                    resultCount;
                                                    context: {$implicit: view.meters.totalCount}
                                                " />
                                        </h2>
                                    </div>
                                    <div class="list-group list-group-flush">
                                        @for (row of view.meters.rows; track row.item.meterId) {
                                            <a
                                                class="list-group-item list-group-item-action search-hit"
                                                [routerLink]="row.link"
                                                (click)="activeModal.close()">
                                                <span class="search-hit-title">
                                                    <span class="search-part">{{
                                                        row.item.meterNo
                                                    }}</span>
                                                    @if (row.item.alloUnitType != null) {
                                                        <span class="search-part">{{
                                                            'mappers_allocationUnitMap.' +
                                                                row.item.alloUnitType
                                                                | translate: 'online' : 'common'
                                                        }}</span>
                                                    } @else if (row.item.meterModel != null) {
                                                        <span class="search-part">{{
                                                            row.item.meterModel
                                                        }}</span>
                                                    }
                                                </span>
                                                <span class="search-hit-detail">
                                                    @if (row.item.address != null) {
                                                        <span class="search-part">{{
                                                            row.item.address
                                                        }}</span>
                                                    }
                                                    @if (row.item.placement != null) {
                                                        <span class="search-part">{{
                                                            row.item.placement
                                                        }}</span>
                                                    }
                                                    @if (
                                                        row.item.printedSerialNo != null &&
                                                        row.item.printedSerialNo !==
                                                            row.item.meterNo
                                                    ) {
                                                        <span class="search-part">{{
                                                            'search_printedMeterNo'
                                                                | translate
                                                                    : 'online'
                                                                    : 'ngonline'
                                                                    : [row.item.printedSerialNo]
                                                        }}</span>
                                                    }
                                                    @if (
                                                        row.item.secondaryMeterNo != null &&
                                                        row.item.secondaryMeterNo !==
                                                            row.item.meterNo
                                                    ) {
                                                        <span class="search-part">{{
                                                            'search_secondaryMeterNo'
                                                                | translate
                                                                    : 'online'
                                                                    : 'ngonline'
                                                                    : [row.item.secondaryMeterNo]
                                                        }}</span>
                                                    }
                                                </span>
                                                <ng-container
                                                    *ngTemplateOutlet="
                                                        systemContext;
                                                        context: {$implicit: row.item}
                                                    " />
                                            </a>
                                        }
                                    </div>
                                    <ng-container
                                        *ngTemplateOutlet="
                                            showingFirst;
                                            context: {$implicit: view.meters}
                                        " />
                                </section>
                            }
                        </div>
                    }

                    @if (view.consumers.totalCount > 0) {
                        <div class="col-lg">
                            <section class="card">
                                <div class="card-header">
                                    <h2 class="search-group-title">
                                        {{ 'titles_residents' | translate: 'online' : 'common' }}
                                        <ng-container
                                            *ngTemplateOutlet="
                                                resultCount;
                                                context: {$implicit: view.consumers.totalCount}
                                            " />
                                    </h2>
                                </div>
                                <div class="list-group list-group-flush">
                                    @for (row of view.consumers.rows; track row.item.consumerId) {
                                        <a
                                            class="list-group-item list-group-item-action search-hit"
                                            [routerLink]="row.link"
                                            (click)="activeModal.close()">
                                            <span class="search-hit-title">
                                                <span class="search-part">{{
                                                    row.item.consumerId
                                                }}</span>
                                                @if (row.item.name != null) {
                                                    <span class="search-part">{{
                                                        row.item.name
                                                    }}</span>
                                                }
                                            </span>
                                            <span class="search-hit-detail">
                                                @if (row.item.proBraLoc != null) {
                                                    <span class="search-part">{{
                                                        row.item.proBraLoc
                                                    }}</span>
                                                }
                                                @if (row.item.consumerNo != null) {
                                                    <span class="search-part"
                                                        >{{
                                                            'search_consumerNo'
                                                                | translate: 'online' : 'ngonline'
                                                        }}
                                                        {{ row.item.consumerNo }}</span
                                                    >
                                                }
                                                @if (row.item.phoneNumber != null) {
                                                    <span class="search-part"
                                                        ><i
                                                            class="bi bi-telephone me-1"
                                                            aria-hidden="true"></i
                                                        >{{ row.item.phoneNumber }}</span
                                                    >
                                                }
                                                @if (row.item.email != null) {
                                                    <span class="search-part"
                                                        ><i
                                                            class="bi bi-envelope me-1"
                                                            aria-hidden="true"></i
                                                        >{{ row.item.email }}</span
                                                    >
                                                }
                                            </span>
                                            <ng-container
                                                *ngTemplateOutlet="
                                                    systemContext;
                                                    context: {$implicit: row.item}
                                                " />
                                        </a>
                                    }
                                </div>
                                <ng-container
                                    *ngTemplateOutlet="
                                        showingFirst;
                                        context: {$implicit: view.consumers}
                                    " />
                            </section>
                        </div>
                    }
                </div>
            }
        }
    }
</div>

<ng-template #resultCount let-count>
    <span class="search-group-count">
        @if (count === 1) {
            {{ 'search_resultCountOne' | translate: 'online' : 'ngonline' : [count.toString()] }}
        } @else {
            {{ 'search_resultCountMany' | translate: 'online' : 'ngonline' : [count.toString()] }}
        }
    </span>
</ng-template>

<ng-template #systemContext let-item>
    <span class="search-hit-context">
        <span class="search-part">{{
            'search_systemNo' | translate: 'online' : 'ngonline' : [item.buildingNo]
        }}</span>
        @if (item.buildingName != null) {
            <span class="search-part">{{ item.buildingName }}</span>
        }
        @if (item.buildingAddress != null) {
            <span class="search-part">{{ item.buildingAddress }}</span>
        }
    </span>
</ng-template>

<ng-template #showingFirst let-group>
    @if (group.rows.length < group.totalCount) {
        <div class="card-footer text-muted small">
            {{
                'search_showingFirst'
                    | translate
                        : 'online'
                        : 'ngonline'
                        : [group.rows.length.toString(), group.totalCount.toString()]
            }}
        </div>
    }
</ng-template>
